import { gql } from '@apollo/client';

export const CREATE_ASG = gql`
  mutation createASGPPP($asg: NrAsgpppInput!) {
    createNrAsgppp(NrAsgPpp: $asg) {
      id
    }
  }
`;
